import './assets/shopfinder.css';const o = "#ffffff", a = "#396e75", e = "#e5fdff", t = "#546223", n = "#f0fae5", i = "#a65523", s = "#fff1e8", l = "#7f3e3e", r = "#ffe2e2", d = "#62625a", _ = "#f8f8e7", c = "#38539a", f = "#707070", p = "#c8f8d1", h = "#87c9c8", g = "#5291b1", w = "rgba(82, 145, 177, 0.1019607843)", k = "#445685", u = "#181d61", z = "rgba(24, 29, 97, 0.1019607843)", V = "#5969d6", C = "#ea999d", b = "#b6577e", m = "rgba(182, 87, 126, 0.1019607843)", v = "#7e3e80", B = "#1e247f", y = "rgba(30, 36, 127, 0.1019607843)", G = "#da7600", O = "#107f47", R = "#d91734", W = "_html_17wfn_46", x = {
  amwayWhite: o,
  darkBlue: a,
  lightBlue: e,
  darkGreen: t,
  lightGreen: n,
  darkOrange: i,
  lightOrange: s,
  darkRed: l,
  lightRed: r,
  darkYellow: d,
  lightYellow: _,
  darkPurple: c,
  darkGrayOnWhite: f,
  dataVizColor1: p,
  dataVizColor2: h,
  dataVizColor3: g,
  dataVizColor3Background: w,
  dataVizColor4: k,
  dataVizColor5: u,
  dataVizColor5Background: z,
  dataVizColor6: V,
  dataVizColor7: C,
  dataVizColor8: b,
  dataVizColor8Background: m,
  dataVizColor9: v,
  dataVizColor10: B,
  dataVizColor10Background: y,
  dataVizAlertOrange: G,
  dataVizSuccessGreen: O,
  dataVizWarningRed: R,
  "no-visible": "_no-visible_17wfn_42",
  html: W,
  "shop-finder-layout": "_shop-finder-layout_17wfn_80",
  "shop-finder-shop-list": "_shop-finder-shop-list_17wfn_87",
  "shop-finder-no-stores-card": "_shop-finder-no-stores-card_17wfn_92",
  "shop-finder-no-stores-card-image": "_shop-finder-no-stores-card-image_17wfn_101",
  "no-shop-card-container": "_no-shop-card-container_17wfn_107",
  "pickup-postalCode-field": "_pickup-postalCode-field_17wfn_117",
  "shop-finder-map": "_shop-finder-map_17wfn_121",
  "shop-list-heading": "_shop-list-heading_17wfn_125",
  "shop-list": "_shop-list_17wfn_125",
  "pickup-stores-google-map": "_pickup-stores-google-map_17wfn_144",
  "pickup-stores-google-map-view": "_pickup-stores-google-map-view_17wfn_148",
  "pickup-stores-google-map-view-fullHeight": "_pickup-stores-google-map-view-fullHeight_17wfn_151",
  "shop-details-container": "_shop-details-container_17wfn_155",
  "shop-details-header": "_shop-details-header_17wfn_163",
  "shop-details-backToShops": "_shop-details-backToShops_17wfn_172",
  "shop-detail-back-icon": "_shop-detail-back-icon_17wfn_175",
  "shop-detail-back-text": "_shop-detail-back-text_17wfn_179",
  "shop-details-info": "_shop-details-info_17wfn_185",
  "shop-details-title": "_shop-details-title_17wfn_188",
  "shop-image": "_shop-image_17wfn_195",
  "shop-details-fields": "_shop-details-fields_17wfn_203",
  "fields-label": "_fields-label_17wfn_213",
  "fields-value": "_fields-value_17wfn_217",
  "open-hours": "_open-hours_17wfn_220",
  "openHours-label": "_openHours-label_17wfn_220",
  "shop-list-container": "_shop-list-container_17wfn_233",
  "view-google-map": "_view-google-map_17wfn_241",
  "view-google-map-text": "_view-google-map-text_17wfn_253",
  "back-to-list": "_back-to-list_17wfn_306",
  "google-layout-drawer-container": "_google-layout-drawer-container_17wfn_335",
  "drawer-title": "_drawer-title_17wfn_339",
  "backLink-icon-cta": "_backLink-icon-cta_17wfn_351",
  "backLink-icon": "_backLink-icon_17wfn_351",
  "skeleton-loading": "_skeleton-loading_17wfn_1"
};
export {
  x as s
};
//# sourceMappingURL=shopfinder.module-e1fb36cc.mjs.map
